import { FiltersProvider } from "domain/Filters";
import { SortingProvider } from "domain/Sorting";
import { HistoryProvider } from "..";
import { EmployeesProvider } from "domain/Employee";

export const HistoryPageProvider = ({ children }) => (
  <SortingProvider>
    <FiltersProvider>
      <HistoryProvider>
        <EmployeesProvider>{children}</EmployeesProvider>
      </HistoryProvider>
    </FiltersProvider>
  </SortingProvider>
);
